import { render, staticRenderFns } from "./ExportInsertPagesConfig.vue?vue&type=template&id=369f2ec8"
import script from "./ExportInsertPagesConfig.vue?vue&type=script&lang=js"
export * from "./ExportInsertPagesConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('369f2ec8')) {
      api.createRecord('369f2ec8', component.options)
    } else {
      api.reload('369f2ec8', component.options)
    }
    module.hot.accept("./ExportInsertPagesConfig.vue?vue&type=template&id=369f2ec8", function () {
      api.rerender('369f2ec8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/Export/ExportInsertPagesConfig.vue"
export default component.exports